.root {
	position: relative;
	display: flex;
	min-width: 0;
}

.menu {
	composes: surface from "../menu.module.css";
	position: absolute;
	top: calc(100% + 4px);
	left: 0;
	z-index: 20;
	min-width: 168px;
	animation: sessionMenuIn 0.14s ease-out;
}

.alignRight {
	left: auto;
	right: 0;
}

.above {
	top: auto;
	bottom: calc(100% + 4px);
}

.item {
	composes: itemBase from "../menu.module.css";
	display: flex;
	align-items: center;
	gap: 10px;
}

.item:hover {
	color: var(--parrot-chat-text);
	background: var(--parrot-chat-menu-hover);
}

.item svg {
	width: 16px;
	height: 16px;
	flex-shrink: 0;
	fill: none;
	stroke: currentColor;
	stroke-width: 2;
	stroke-linecap: round;
	stroke-linejoin: round;
}

/* Delete is destructive — tinted red by default, stronger on hover. */
.itemDanger {
	color: var(--parrot-chat-error);
}

.itemDanger:hover {
	color: var(--parrot-chat-error);
	background: rgba(231, 45, 26, 0.1);
}

@keyframes sessionMenuIn {
	from {
		opacity: 0;
		transform: translateY(-4px);
	}
	to {
		opacity: 1;
		transform: translateY(0);
	}
}
